export default "__VITE_ASSET__CXccZHJG__"